const INTERPOLATION_REGEX = /{{(\s*[\w\d]+\s*)}}/gi;

const getBuiltInValues = (): Record<string, string> => ({
  currentyear: `${new Date().getFullYear()}: Price, specs & boot space`,
});

export const interpolateContent = (content: string): string => {
  const builtInValues = getBuiltInValues();
  return content.replace(INTERPOLATION_REGEX, (match, token: string) => {
    const key = token.trim().toLowerCase();
    return builtInValues[key] ?? match;
  });
};
